import React from "react";
import {Checkbox, FormControlLabel} from "@mui/material";
import {Images} from 'assets/images';

export const CheckboxMain = ({
                                 checked,
                                 onChange,
                                 className,
                                 label,
                                 disabled,
                                 value
                             }) => {
    return (
        <div className={`checkbox-box ${className ? className : ""}`}>
            <FormControlLabel
                value={value}
                label={label}
                disabled={disabled}
                control={
                    <Checkbox
                        checked={checked}
                        onChange={onChange}
                        icon={<Images.CheckboxSvg/>}
                        checkedIcon={<Images.CheckboxCheckedSvg/>}
                    />
                }
            />
        </div>
    );
};
